import { render, staticRenderFns } from "./HumanResourcesSection.vue?vue&type=template&id=ddeedc1a&scoped=true&"
import script from "./HumanResourcesSection.vue?vue&type=script&lang=js&"
export * from "./HumanResourcesSection.vue?vue&type=script&lang=js&"
import style0 from "./HumanResourcesSection.vue?vue&type=style&index=0&id=ddeedc1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeedc1a",
  null
  
)

export default component.exports